module.exports = __webpack_public_path__ + "media/images/admin/icons/phone-off-b18e4ae142ee0d8930a86cb42cd4d1d1.svg";